
    import I18n from 'i18nObj';
    
      import 'translations/past_global_announcements';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('past_global_announcements');
  